import React, { useEffect, useState, } from "react"
import TextField from "@material-ui/core/TextField"
import Link from "@material-ui/core/Link"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { mapClient, } from "globalInstance"
import { MapLocation, } from "indoor-map-lib"
import style from "./style.module.scss"
import { connect, useSelector, } from "react-redux"
import { selectState, slice, } from "app/App/redux"

const mapDispatch = { ...slice.actions, }
const connector = connect(null, mapDispatch)

let latestRequet = 0
enum InputType {
  ToLocation = "toLocation",
  FromLocation = "fromLocation"
}

/**
 * ルート案内専用のリストを表示するコンポーネント
 * 振る舞いが大きく変わるため別コンポーネントにしています
 */
function Navigator () {
  const {
    currentLocationId,
    hasUserPosition,
  } = useSelector(selectState)

  const [locations, setLocations] = useState<MapLocation[]>([])
  const [fromLocations, setFromLocations] = useState<MapLocation[]>([])
  const [fromLocationId, setFromLocationId] = useState<string | null>(null)
  const [toLocations, setToLocations] = useState<MapLocation[]>([])
  const [toLocationId, setToLocationId] = useState<string | null>(null)

  useEffect(() => {
    // ロケーション一覧を取得
    const jaCollator = new Intl.Collator("ja")
    const locations = mapClient.getLocations().sort((a, b) => {
      return jaCollator.compare(a.name, b.name)
    })
    setLocations(locations)
    setFromLocations(locations)
    setToLocations(locations)
  }, [])

  useEffect(() => {
    // ロケーションが選択中の場合は目的地に設定
    if (currentLocationId) {
      setToLocationId(currentLocationId)
      handleLocationChange(fromLocationId, currentLocationId)
    }
  }, [currentLocationId, fromLocationId])

  /**
   * 出発地または目的地の値が変更された際の処理
   * @param fromId
   * @param toId
   */
  const handleLocationChange = (fromId: string | null, toId: string | null) => {
    if (fromId === toId) return
    if (!fromId || !toId) return

    // ルート検索を行う
    mapClient.showRoute(fromId, toId)
  }

  /**
   * 出発地または目的地のテキストボックスの値が変更された際の処理
   * キーワードからロケーションを検索し、候補を表示します
   * @param value
   * @param type
   */
  const handleChangeInput = async (value: string, type: InputType) => {
    const nowTime = Date.now()
    latestRequet = nowTime

    if (value === "") {
      // キーワードクリア時
      if (type === InputType.FromLocation) {
        setFromLocations(locations)
      }
      if (type === InputType.ToLocation) {
        setToLocations(locations)
      }
      return
    }

    const hits = await mapClient.search(value)

    const filteredHits = hits
      .filter(h => h.assetType === "location" && locations.findIndex(l => l.id === h.id) >= 0)
    const filteredLocations = locations.filter(l => filteredHits.findIndex(h => h.id === l.id) >= 0)

    // 以降に検索が行われた場合は更新処理をスキップ
    if (latestRequet > nowTime) return

    if (type === InputType.FromLocation) {
      setFromLocations(filteredLocations)
    } else if (type === InputType.ToLocation) {
      setToLocations(filteredLocations)
    }
  }

  /**
   * 現在位置からのルート検索クリック時の処理
   */
  const handleRouteSearchAtCurrentPosClick = () => {
    if (toLocationId) {
      mapClient.showRouteFromCurrentPosition(toLocationId)
    }
  }

  return (
    <div className={style.frame}>
      <div>
        {(hasUserPosition) && (<div className={style.section}>
          <Link
            className={style.routeSearchAtCurrentPos}
            color="secondary"
            underline="always"
            onClick={handleRouteSearchAtCurrentPosClick}>現在位置から</Link>
        </div>)}
        <div className={style.section}>
          <Autocomplete
            options={fromLocations}
            getOptionLabel={(option) => option.name}
            getOptionSelected={(option, value) => option.name === value.name}
            value={fromLocations.find(location => location.id === fromLocationId) || null}
            onChange={(_, value) => {
              const locationId = (value || {}).id || ""
              setFromLocationId(locationId)
              handleLocationChange(locationId, toLocationId)
            }}
            blurOnSelect={true}
            renderInput={(params) => (
              <TextField
                {...params}
                label="出発地"
                variant="outlined"
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                  handleChangeInput(e.target.value, InputType.FromLocation)
                }}
              />
            )}
          />
        </div>
        <div className={style.section}>
          <Autocomplete
            options={toLocations}
            getOptionLabel={(option) => option.name}
            getOptionSelected={(option, value) => option.name === value.name}
            value={toLocations.find(location => location.id === toLocationId) || null}
            onChange={(_, value) => {
              const locationId = (value || {}).id || ""
              setToLocationId(locationId)
              handleLocationChange(fromLocationId, locationId)
            }}
            blurOnSelect={true}
            renderInput={(params) => (
              <TextField
                {...params}
                label="目的地"
                variant="outlined"
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                  handleChangeInput(e.target.value, InputType.ToLocation)
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default connector(Navigator)
